import { range, sumBy } from 'lodash';
import { ReactComponent as LeftDefs } from '../../../images/manifold/left.defs.svg';
import { ReactComponent as LeftWithPumpDefs } from '../../../images/manifold/left-with-pump.defs.svg';
import { ReactComponent as MiddleDefs } from '../../../images/manifold/middle.defs.svg';
import { ReactComponent as RightDefs } from '../../../images/manifold/right.defs.svg';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { LeftPaths } from './LeftPaths';
import { MiddlePaths } from './MiddlePaths';
import { RightPaths } from './RightPaths';
import { LeftWithPumpPaths } from './LeftWithPumpPaths';

export const SVG_TRANSFORM = {
  // These numbers need to be changed collectively
  // as the scale doesn't seem to set the origin as expected
  scale: 0.93,
  xTransform: -370,
  yTransform: 990,
};

export const BRACKET_SIZE = 18.4 + 2 * 6.24;

const LEFT_PATH_DETAILS = {
  xOffset: 303,
  yOffset: -56,
  portsContainedInImage: 1,
};

const LEFT_WITH_PUMP_PATH_DETAILS = {
  portsContainedInImage: 1,
};

export const MIDDLE_PATH_DETAILS = {
  xOffset: 185,
  yOffset: -56,
  actuatorDefaultWidth: 83.2,
};

const RIGHT_PATH_DETAILS = {
  xOffset: -32,
  yOffset: -56,
  overlapWidth: -31,
};

type Props = {
  manifold: DataForDesignDrawingsManifold;
};

export const ManifoldDiagram = ({ manifold }: Props) => {
  const numberOfPorts = sumBy(manifold.rooms, room => room.numberOfPorts);
  const hasPump = manifold.pumpId != null;
  const portsContainedInImage = hasPump
    ? LEFT_WITH_PUMP_PATH_DETAILS.portsContainedInImage
    : LEFT_PATH_DETAILS.portsContainedInImage;

  return (
    <g
      transform={`matrix(${SVG_TRANSFORM.scale}, 0, 0, ${SVG_TRANSFORM.scale}, ${SVG_TRANSFORM.xTransform}, ${SVG_TRANSFORM.yTransform})`}
    >
      <LeftDefs />
      <LeftWithPumpDefs />
      <MiddleDefs />
      <RightDefs />
      {hasPump ? (
        <LeftWithPumpPaths xTransform={0} yTransform={0} />
      ) : (
        <LeftPaths xTransform={LEFT_PATH_DETAILS.xOffset} yTransform={LEFT_PATH_DETAILS.yOffset} />
      )}
      {range(0, numberOfPorts - portsContainedInImage).map(portNumber => (
        <MiddlePaths
          key={portNumber}
          xTransform={MIDDLE_PATH_DETAILS.xOffset + MIDDLE_PATH_DETAILS.actuatorDefaultWidth * portNumber}
          yTransform={MIDDLE_PATH_DETAILS.yOffset}
        />
      ))}
      <RightPaths
        xTransform={
          RIGHT_PATH_DETAILS.xOffset +
          (numberOfPorts !== 1
            ? MIDDLE_PATH_DETAILS.actuatorDefaultWidth * (numberOfPorts - LEFT_PATH_DETAILS.portsContainedInImage)
            : RIGHT_PATH_DETAILS.overlapWidth)
        }
        yTransform={RIGHT_PATH_DETAILS.yOffset}
      />
    </g>
  );
};
